import ImageAtom from "@/app/shared-components/image-wrapper/image";

import { CountryChangeDropDownItemProps } from "./types/country-change-modal-types";

export function CountryChangeDropDownItem({
  countryFlag,
  country,
  language,
}: Readonly<CountryChangeDropDownItemProps>) {
  return (
    <div className="flex w-full  h-[40px] !justify-start !items-center !px-spacing-xs">
      <ImageAtom
        image={countryFlag}
        styleClass="w-[24px] h-[24px] !mr-[8px] mb-[4px]"
      />
      <span className="!mr-[8px]">{country}</span>
      {" / "}
      <span className="!ml-[4px]">{language}</span>
    </div>
  );
}
